<app-generic-label
  [label]="label"
  [selected]="(selectedLabel$ | async)?.id === label.id"
  [scale]="(labelScale$ | async)"
  [sequence]="sequence"
  [isCollapsed]="isCollapsed"
  [tagCollapsed]="tagCollapsed"
  [pinDraggable]="tagDraggable"
  [tagDraggable]=""
  [descriptionCollapsed]="descriptionCollapsed"
  [hasContent]="hasContent"
  (labelUpdated)="handleLabelUpdated($event)"
  (offsetUpdated)="handleOffsetUpdated($event)"
  (tagClicked)="handleTagClicked($event)"
  (pinClicked)="handlePinClicked($event)"
  (displayUpdated)="handleDisplayUpdated($event)"
  (positionUpdated)="handlePositionUpdated($event)"
  (hoverStart)="handleHoverStart($event)"
  (hoverEnd)="handleHoverEnd($event)">

  <!-- header -->
  <div class="html" #title [innerHTML]="label.title | markdown" label-header>
  </div>

  <!-- Body -->
  <div class="html" label-body>

    <!-- content blocks -->
    <div *ngIf="label.contentBlocks" class="mv-1" appEventFence>
      <app-content-blocks
        [contentBlocks]="label.contentBlocks"
        [layout]="'compact'">
      </app-content-blocks>
    </div>

    <!-- description -->
    <div
      *ngIf="label.description"
      [innerHTML]="label.description | markdown"
      data-test="labelDescription">
    </div>

  </div>

</app-generic-label>
